import { ThunkResult } from 'store/store';
import {
    createServiceBoardServiceFetchFailureAction,
    createServiceBoardServiceFetchRequestAction,
    createServiceBoardServiceFetchSuccessAction,
} from 'store/ServiceBoardService/serviceBoardServiceAction';
import { AccessType } from 'models/accessType';
import { DEFAULT_LANGUAGE } from 'models/constants';
import { matchServiceByKey } from 'core/utils/service-matchers';
import { ServicesApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { WidgetType } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { logError } from 'core/services/common/logging/logger';

export const buildServiceBoardServiceKey = (accessType: AccessType, language: string) => `${accessType}_${language}`;

export const getAccessServices = (language?: string): ThunkResult => {
    return getBoardServices(AccessType.HasAccess, language || DEFAULT_LANGUAGE);
};

export const getBoardServices = (accessType: AccessType, language?: string, additionalServices?: string): ThunkResult => {
    return async (dispatch, state) => {
        language ||= DEFAULT_LANGUAGE;
        const key = buildServiceBoardServiceKey(accessType, language);
        const { boardServices: { data } } = state();
        if (Object.keys(data).includes(key)) {
            return;
        }

        dispatch(createServiceBoardServiceFetchRequestAction(key));
        try {
            const service = await ServicesApi.getServices(undefined, language, accessType, additionalServices);
            dispatch(createServiceBoardServiceFetchSuccessAction(key, service?.services, service?.nonSgmServices));
        } catch (error: unknown) {
            logError(error);
            dispatch(createServiceBoardServiceFetchFailureAction(key));
        }
    };
};

export const getServiceByKey = <T extends { serviceKey?: Nullable<string> }>(
    haystack: Nullable<T[]>,
    key: string,
): T | null => {
    if (!haystack) {
        return null;
    }
    const matching = haystack.filter(matchServiceByKey(key));
    return matching[0] || null;
};

export const hasServiceKey = <T extends { serviceKey?: Nullable<string> }>(
    haystack: Nullable<T[]>,
    key: Nullable<string>,
): boolean => {
    return !!haystack && !!key && haystack.some(matchServiceByKey(key));
};

export const getServiceUrl = (widgetType: WidgetType, baseUrl?: string): string | undefined => {
    if (!baseUrl) {
        return undefined;
    }

    const trimedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

    switch (widgetType) {
        case WidgetType.SGMARKETS:
            return trimedBaseUrl + 'myfeed';
        default:
            return trimedBaseUrl;
    }
};
